/**
 * Short-URL handler for referral links.
 *
 * Visitors hit https://2highexotics.com/r/<source>?to=/menu
 * This component:
 *  1. Synchronously redirects via window.location.replace() to the backend
 *     tracking endpoint /api/go/<source>?to=...
 *  2. The backend logs the click then 302s the visitor to the final
 *     destination (e.g. /menu?ref=<source>), staying on the brand domain.
 *
 * Result: the partner posts a clean URL like 2highexotics.com/r/choke
 * instead of the noisy /api/go/choke. Clicks still tracked the same way.
 */
import React from "react";
import { useParams, useSearchParams } from "react-router-dom";

export default function ReferralRedirect() {
  const { source } = useParams();
  const [params] = useSearchParams();
  const to = params.get("to") || "/";

  React.useEffect(() => {
    const slug = (source || "").toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 48) || "unknown";
    const url = `/api/go/${slug}?to=${encodeURIComponent(to)}`;
    // Use replace() so this hop doesn't pollute browser history
    window.location.replace(url);
  }, [source, to]);

  return (
    <div
      style={{
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        background: "#0a0a0a", color: "#c9a86b",
        fontFamily: "system-ui,-apple-system,sans-serif",
        fontSize: "11px", letterSpacing: "0.18em", textTransform: "uppercase",
      }}
    >
      Redirecting…
    </div>
  );
}
